<script context="module">
		import {CurrencyConversionRates } from '../../stores'

		let rates = {}

		CurrencyConversionRates.subscribe( (newRates) => {
			rates = newRates
		})
		export const currencyValue = (fsymb, amount, tsymb = "usd") => {
			return Math.floor(amount * (rates?.[fsymb]?.[tsymb] || 0) * 100) / 100
		}
</script>
<script>
	import { onMount  } from "svelte";
	import { onInterval } from "../../scripts/utils";
	import {
        getCurrenciesInfos
    } from "../../scripts/stake-api";

	import {
		Dropdown,
		initDropdown,	
		controllable,	
		Icon,
		
	} from "svantic";

	initDropdown()

	import * as CryptoIcons from 'svelte-cryptoicon'

	import { User, BetSettingsLocal } from '../../stores'


	

	let Balances = { }
	User.subscribe( userData => {
		Balances = { ... userData.balances }
	})

	let i_dropdown
	let i_coin = $BetSettingsLocal.currency || 'btc'
	let i_fiat = "usd"
	let balance = 0

	//$: console.log("balance: ", balance)
	$:  {
		 balance = Balances[i_coin] 
		// balance_value = Math.floor(balance * $CurrencyConversionRates[i_coin][i_fiat] * 100) / 100
	
		}



	
    const interval_coinrates = 60 * 1000 * 5
    let interval_h 
    
	onMount(() => {

        interval_h = onInterval(async function(){

            let result = await getCurrenciesInfos();
      		CurrencyConversionRates.update({lastUpdate: new Date(), ... result.data})


        } , interval_coinrates, false)

		
		return () => {
			interval_h()
		}

     })


	function capitalizeFirstLetter(string) {
		return string.charAt(0).toUpperCase() + string.slice(1);
	}

	
	const DropdownCurrencyController = controllable(controller=>{
		controller.setSelected(i_coin)
	})
  //  export let items
</script>

<Dropdown	bind:this={$DropdownCurrencyController} 
					
			long
			selection
			style={{"min-width": "16em"}}
			onMount={async (elem) => {
				console.log("dropdown 'currency' element ", elem)
			}}
			settings={{
				action: 'select',
				onChange: (value, text, $selectedItem) => {
					i_coin = value; // custom action

					//update BetSettings store
					BetSettingsLocal.update({currency: value })
				},
			}}>
			<input name="coin" type="hidden" bind:value={i_coin}/>

			<!-- <Dropdown.text>Select game</Dropdown.text> -->
			<i class="dropdown icon"></i>
			<Dropdown.Text > 
					<span  style={ "margin-right: 0.4em; text-align: left; float: left; font-size: smaller; color: #414141"} >
						{currencyValue(i_coin, balance, i_fiat)}{ i_fiat == "usd" ? "$" : "€"}
					</span>
					<span  style={ " text-align: right; font-weight: 700"}>
						{ (Math.floor(balance*1e8)/1e8).toFixed(8) }
						{i_coin.toUpperCase()}
					</span>	
					<span  style={ " float:right; text-align: right; font-weight: 700"}>
						<svelte:component this={CryptoIcons[capitalizeFirstLetter(i_coin)]} size="14"></svelte:component>
					</span>
			</Dropdown.Text>
			<Dropdown.Menu>
				{#each Object.entries(Balances) as [currency, amount],i (currency)}
					<Dropdown.Item selected={i == 0 ? true : false} value={currency} style={ {"text-align": "right"} } class="dropdown-currency-item">
						<span  style={ "margin-right: 0.3em; text-align: left; float: left; font-size: smaller; color: #414141"} >
							{currencyValue(currency, amount, i_fiat)}{ i_fiat == "usd" ? "$" : "€"}
						</span>
						 { (Math.floor(amount*1e8)/1e8).toFixed(8) }
						 {currency.toUpperCase()}
						 <svelte:component this={CryptoIcons[capitalizeFirstLetter(currency)]} size="13"></svelte:component>						 
					</Dropdown.Item>
				{/each}
			</Dropdown.Menu>
		</Dropdown>

<style>

	:global(.dropdown-currency-item > svg), :global(.ui.dropdown > .text > svg)   {
		vertical-align: middle;
	}
</style>
